import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import {
  getTerminalAuthContext,
  isTerminalAuthorized,
} from "@/actions/terminal-auth-actions"
import { getTerminalHeadMeta } from "@/lib/terminal/metadata"
import { resolveTerminalRouteMode } from "@/lib/terminal/route-access"

export const Route = createFileRoute("/_terminal")({
  head: () => ({
    meta: getTerminalHeadMeta(),
  }),
  beforeLoad: async ({ location }) => {
    const authContext = await getTerminalAuthContext()
    const hasTerminalAccess =
      !!authContext.user && isTerminalAuthorized(authContext.userType)
    const mode = resolveTerminalRouteMode({
      pathname: location.pathname,
      isAuthorized: hasTerminalAccess,
    })

    if (mode === "login") {
      throw redirect({ to: "/terminal/login" })
    }

    return {
      hasTerminalAccess,
      isSignedIn: Boolean(authContext.user),
    }
  },
  component: Outlet,
})
